// Same fixed-project pattern as src/lib/billing.js — Edifice View is one
// shared project, not one-per-buyer, so there's no per-deployment config
// to plumb through here either.
const FUNCTIONS_BASE = "https://us-central1-edifice-view.cloudfunctions.net";

export function sendTestSms(facilityId) {
  return fetch(`${FUNCTIONS_BASE}/sendTestSms`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ facilityId }),
  }).then(async (res) => {
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || "sendTestSms failed");
    return data;
  });
}
